// Central source of truth for entity categories.
// Keep in sync with /app/backend/entity_types.py

export const ENTITY_TYPES = [
  { value: 'campgrounds_resorts',       label: 'Campgrounds/Resorts' },
  { value: 'concessionaire',            label: 'Concessionaire' },
  { value: 'conservancies_land_trusts', label: 'Conservancies/Land Trusts' },
  { value: 'industry_partners',         label: 'Industry Partners' },
  { value: 'manufacturers',             label: 'Manufacturers' },
  { value: 'outdoor_education',         label: 'Outdoor Education' },
  { value: 'outfitters_guides',         label: 'Outfitters/Guides' },
  { value: 'retailers',                 label: 'Retailers' },
  { value: 'rv_partners',               label: 'RV Partners' },
  { value: 'state_parks_dnr',           label: 'State Parks/DNR' },
  { value: 'summer_camps',              label: 'Summer Camps' },
  { value: 'tdas',                      label: 'TDAs' },
];

// Slug → label
export const ENTITY_TYPE_LABELS = ENTITY_TYPES.reduce((acc, t) => {
  acc[t.value] = t.label;
  return acc;
}, {});

// Brand-aligned color per type (used by Map markers / chips)
export const ENTITY_TYPE_COLORS = {
  campgrounds_resorts:       '#22C55E', // green
  concessionaire:            '#A855F7', // purple
  conservancies_land_trusts: '#10B981', // emerald
  industry_partners:         '#8B5CF6', // violet
  manufacturers:             '#06B6D4', // cyan
  outdoor_education:         '#EC4899', // pink
  outfitters_guides:         '#FF0000', // red (primary brand)
  retailers:                 '#F59E0B', // amber
  rv_partners:               '#F97316', // orange
  state_parks_dnr:           '#0EA5E9', // sky
  summer_camps:              '#EAB308', // yellow
  tdas:                      '#6366F1', // indigo
};

// Short label variants for tight UI spaces (chips, map legend)
export const ENTITY_TYPE_SHORT_LABELS = {
  campgrounds_resorts:       'Camp/Resort',
  concessionaire:            'Concessionaire',
  conservancies_land_trusts: 'Conservancy',
  industry_partners:         'Industry',
  manufacturers:             'Mfr',
  outdoor_education:         'Education',
  outfitters_guides:         'Guide',
  retailers:                 'Retailer',
  rv_partners:               'RV Partner',
  state_parks_dnr:           'State Park',
  summer_camps:              'Summer Camp',
  tdas:                      'TDA',
};

export const getTypeLabel = (value) => ENTITY_TYPE_LABELS[value] || value || 'Partner';
export const getTypeColor = (value) => ENTITY_TYPE_COLORS[value] || '#FF0000';
export const getTypeShortLabel = (value) => ENTITY_TYPE_SHORT_LABELS[value] || getTypeLabel(value);
